import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function AdminPayments() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/admin/payments").then((r) => setItems(r.data)).catch(() => {}); }, []);
  return (
    <div data-testid="admin-payments">
      <h1 className="font-display font-black text-3xl mb-8">Paiements</h1>
      <div className="card-dark overflow-x-auto">
        {items.length === 0 ? <div className="p-10 text-center text-slate-500 text-sm">Aucun paiement enregistré.</div> : (
          <table className="w-full text-sm">
            <thead className="text-left text-slate-500 border-b border-white/10">
              <tr><th className="p-4">Prestataire</th><th className="p-4">Montant</th><th className="p-4">Devise</th><th className="p-4">Statut</th><th className="p-4">Date</th></tr>
            </thead>
            <tbody>
              {items.map((p) => (
                <tr key={p.id} className="border-b border-white/5">
                  <td className="p-4 font-mono">{p.provider}</td>
                  <td className="p-4">{p.amount?.toFixed(2)} €</td>
                  <td className="p-4 text-slate-400">{p.currency}</td>
                  <td className="p-4 font-mono text-xs">{p.status}</td>
                  <td className="p-4 text-slate-500">{(p.created_at || "").slice(0, 16).replace("T", " ")}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
